import { Component, OnInit, OnDestroy } from '@angular/core';
import { SharedService } from '../../../services/shared.service';

@Component({
  selector: 'form-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class VTuberSupportPreviewComponent implements OnInit, OnDestroy {
  support: any;

  constructor(private shared: SharedService) {}

  ngOnInit() {
    this.support = this.shared.getCookie(SharedService.PREVIEW_SUPPORT_COOKIE)
    this.support.plans = this.support.plans
    .filter(item => {
      return item.status === undefined || item.status === 'approve'
    })
    .sort((a, b) => {
      if (parseInt(a.amount) > parseInt(b.amount)) return 1;
      if (parseInt(a.amount) < parseInt(b.amount)) return -1;
      return 0;
    })
    if (this.support === undefined) {
      this.shared.redirect('/rooms');
    }

    console.log(this.support)
  }

  ngOnDestroy() {
    this.shared.removeCookie(SharedService.PREVIEW_SUPPORT_COOKIE)
  }
}
